import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';

interface NCFileDetailsNCFileProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const NCFileDetailsNCFileComponent: FC<NCFileDetailsNCFileProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  ncFileData,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  const { ncFileDataLoading, ncFileId } = useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
        <NCFileListOrSingleItem ncFileData={[ncFileData.data]} ncFileDataLoading={!ncFileData.wasLoaded && ncFileDataLoading} ncFileId={ncFileId} />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFile = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFileComponent);

export { NCFileDetailsNCFile };
